import { IApplicationState } from '../../types/redux';
import { selectUser } from './selectUser';

export const selectIsUserAuthenticated = (state: IApplicationState): boolean => {
  const { isAuthenticated } = selectUser(state);

  return isAuthenticated;
};
